import React, { useMemo, useEffect, useState } from "react";
import styled from "styled-components";
import Typography from "@material-ui/core/Typography";
import { withStyles } from "@material-ui/core/styles";
import _ from "lodash";
import moment from "moment";
import CircularProgress from "@material-ui/core/CircularProgress";
import ShareAccordionExpandable from "./shareAccordionExpandable";

const styles = () => ({
  dialogTitle: {
    fontFamily: "work sans",
    fontSize: "20px",
    marginLeft: "25px",
    fontWeight: "500"
  }
});

const StyledContainer = styled.div`
  display: flex;
  height: 80px;
  border-bottom: 1px solid #DADCE0;
  align-items: center;
`;

const AccordionGroupWrapper = styled.div`
  width: 100%;
  max-height: 43vh;
  overflow: auto;
`;

const AccordionGroup = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  box-shadow: 0px 10px 20px rgba(173, 174, 174, 0.25);
`;

const StyledAccordionDetails = styled.div`
  color: #5f6368;
  display: flex;
  width: 100%;
  padding: 0em 1em;
  align-items: center;
`;

const AccordionDetailShareInformation = styled.div`
  padding: 0.3em 0;
  margin-left: auto;
  text-align: end;
`;

const AccordionDetailSharedBy = styled.div`
  font-family: "Work Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 19px;
  color: #000;
  margin-bottom: 0.3em;
`;

const AccordionDetailSharedTime = styled.div`
  font-family: "Work Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 16px;
  color: #5F6368;
`;

const AccordionDetailShareDate = styled.div`
  font-family: "Work Sans";
  font-style: normal;
  font-weight: 500;
  font-size: 20px;
  color: #000;
  float: left;
  width: 40%;
  display: flex;
  align-items: center;
  line-height: 23px;
  padding: 0.3em 0;
  height: 100%;
  box-sizing: border-box;
`;

const CollapsibleSharedDetail = styled.div`
  font-family: 'Work Sans';
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 18px;
  color: #5F6368;
  margin-left: 25px;
  display: flex;
  align-items: center;
`;

const LoadingContainer = styled.div`
  align-items: center;
  display: flex;
  justify-content: center;
  padding: 10px 0;
  width: 100%;
`;

const ShareAccessButton = styled.div`
  text-transform: none;
  font-size: 14px;
  line-height: 16px;
  margin-left: auto;
  font-family: work sans;
  margin-right: 25px;
  color: ${props => (props.shareAccess ? "#005aa9" : "#C40A0A")};
  cursor: pointer;
`;

const CollapsibleAccessText = styled.div`
  font-family: 'Work Sans';
  font-style: italic;
  font-weight: 400;
  font-size: 14px;
  line-height: 16px;
  color: #5F6368;
  display: flex;
  align-items: center;
  margin-right: 20px;
`;

const StyledShareDetails = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  padding: 0em 1em;
  align-items: center;
`;

const CollapsibleSharedEmail = styled.div`
   font-family: 'Work Sans';
   font-style: normal;
   font-weight: 500;
   font-size: 14px;
   line-height: 18px;
   color: #5F6368;
   display: flex;
   align-items: center;
   margin-left: 5px;
 `;

const ShareHistoryModal = ({ shareHistory, setShareHistory, updateShareRecords, rgiId, classes }) => {
  const [shareAccess, setShareAccess] = useState(false);
  const getFormattedShareList = useMemo(() => {
    const updateCreatedAt = shareHistory.map(history => ({ ...history, createdAt: moment.utc(history.createdAt).format("YYYY-MM-DD H:mm") }));
    const groupedShares = _.groupBy(updateCreatedAt, "createdAt");

    return Object.entries(groupedShares)
      .map(x => ({
        sortDate: moment.utc(x[0]),
        shareDate: moment.utc(x[0]).local().format("MMMM Do, YYYY"),
        sharedAt: moment.utc(x[0]).local().format("hh:mm A"),
        sharedBy: `${x[1][0].contact?.firstName} ${x[1][0].contact?.lastName}`,
        recipients: x[1]
      })).sort((a, b) => b.sortDate - a.sortDate);
  }, [shareHistory]);

  useEffect(() => {
    if (shareHistory && shareHistory.length) {
      setShareAccess(shareHistory[0].unshared);
    }
  }, [shareHistory]);

  const renderCollapsibleShareDetails = recipient => (
    <StyledShareDetails>
      <CollapsibleSharedEmail>{recipient.sentTo}</CollapsibleSharedEmail>
      {recipient.unshared && <CollapsibleAccessText>Access removed</CollapsibleAccessText>}
    </StyledShareDetails>

  );

  const renderCollapsibleShareRows = recipients => {
    const rows = [];
    const orderedRecipients = _.orderBy(recipients, ["sentTo"], ["asc"]);
    rows.push(...orderedRecipients.map(recipient => renderCollapsibleShareDetails(recipient)));

    return rows;
  };

  const updateShareAccess = () => {
    const newHistory = shareHistory.map(item => ({
      ...item,
      unshared: !item.unshared
    }));
    setShareHistory(newHistory);
    const unshared = newHistory[0].unshared;
    updateShareRecords({ rgiId, unshared });
  };

  const renderReportShares = shares =>
    shares?.map(
      (share, idx) =>
        <ShareAccordionExpandable
          key={idx}
          headerContent={
            <StyledAccordionDetails>
              <AccordionDetailShareDate>{share?.shareDate}</AccordionDetailShareDate>
              <AccordionDetailShareInformation>
                <AccordionDetailSharedBy>{`Shared by ${share?.sharedBy}`}</AccordionDetailSharedBy>
                <AccordionDetailSharedTime>{`Shared at ${share?.sharedAt}`}</AccordionDetailSharedTime>
              </AccordionDetailShareInformation>
            </StyledAccordionDetails>
          }
          rowsContent={renderCollapsibleShareRows(share?.recipients)}
        />
    );

  return (
    <div style={{width: "800px"}}>
      <StyledContainer>
        <Typography style={{ fontWeight: "500px" }} className={classes.dialogTitle}>Share history</Typography>
        <ShareAccessButton
          shareAccess={shareAccess}
          onClick={() => {
            updateShareAccess();
          }}
        >
          {shareAccess ? "Restore access for all recipients" : "Remove access from all recipients"}
        </ShareAccessButton>
      </StyledContainer>
      <AccordionGroupWrapper>
        {(shareHistory && shareHistory.length) ?
          <AccordionGroup>{renderReportShares(getFormattedShareList)}</AccordionGroup> :
          <LoadingContainer>
            <CircularProgress size="5%" thickness={2} />
          </LoadingContainer>}
      </AccordionGroupWrapper>
    </div>
  );
};

export default withStyles(styles)(ShareHistoryModal);
